import React, { Component } from "react";
import colors from "../../colors";
// import menu from "../data/data";//menu
import BudgetTable from "../../BudgetTable";

import Slider from "./Slider";
import MediaQuery from "react-responsive";

const budget = {
  header: [
    "2016-2017",
    "2017-2018",
    "2018-2019",
    "2019-2020",
    "2020-2021",
    "2021-2022",
    "2022-2023",
    "2023-2024",
  ],
  rows: {
    row1: [
      "Satellite Data",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row2: [
      "Field Experimentation & OutSoursing Activities",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row3: [
      "NRSC Manpower",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row4: [
      "Project Scientists",
      "0.0",
      "8.0",
      "8.0",
      "8.0",
      "8.0",
      "8.0",
      "8.0",
      "8.0",
      "56.3",
    ],
    row5: [
      "Data Analysis",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row6: [
      "Hardware & Software + Maintenance",
      "280.0",
      "450.0",
      "0.0",
      "33.3",
      "33.3",
      "33.3",
      "33.3",
      "33.3",
      "896.3",
    ],
    row7: [
      "ALT DEM / High Resolution Satellite DEM Generation",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row8: [
      "Travel & Field Works",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
      "0.0",
    ],
    row9: [
      "Training & Workshops",
      "0.0",
      "22.9",
      "22.9",
      "22.9",
      "22.9",
      "22.9",
      "22.9",
      "22.9",
      "159.9",
    ],
    row10: [
      "Sub - Total 1",
      "280.0",
      "480.9",
      "30.9",
      "64.1",
      "64.1",
      "64.1",
      "64.1",
      "64.1",
      "1112.5",
    ],
    row11: [
      "Project Management @ 5% of Sub - Total 1",
      "14.0",
      "24.0",
      "1.5",
      "3.2",
      "3.2",
      "3.2",
      "3.2",
      "3.2",
      "55.6",
    ],
    row12: [
      "Sub - Total 2",
      "294.0",
      "504.9",
      "32.4",
      "67.3",
      "67.3",
      "67.3",
      "67.3",
      "67.3",
      "1168.1",
    ],
    row13: [
      "Organization Overheads @ 5% of Sub - Total 2",
      "14.7",
      "25.2",
      "1.6",
      "3.4",
      "3.4",
      "3.4",
      "3.4",
      "3.4",
      "58.4",
    ],
    row14: [
      "Grand Total",
      "308.7",
      "530.2",
      "34.1",
      "70.7",
      "70.7",
      "70.7",
      "70.7",
      "70.7",
      "1226.5",
    ],
  },
};
export default class FLFinancialProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
          height: "800px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />

          <div className="card" style={{ flexGrow: "1", overflowX: "auto" }}>
            <MediaQuery minWidth={991}>
              <div
                className="card-body"
                style={{ margin: "auto", padding: "10px" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Capacity Building{" "}
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
            <MediaQuery maxWidth={991}>
              <div className="card-body" style={{ padding: "10px" }}>
                <h3 align="center" style={{ color: "#002171" }}>
                  Capacity Building{" "}
                </h3>{" "}
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Financial Proposal
                </h5>
                <BudgetTable data={budget} />
                {/* <img class="card-img-top" height="400" width="800" src={this.props.budget}/> */}
              </div>
            </MediaQuery>
          </div>
        </div>
      </div>
    );
  }
}
